<app-side-menu>
  <div class="cashflow-container">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div>
            <h1 class="page-title">
              <i class="fas fa-chart-line me-3"></i>
              Espelho financeiro
            </h1>
            <p class="page-subtitle mb-0">
              Visão consolidada do que <strong>entra</strong> (Contas a Receber) e do que <strong>sai</strong> (Contas a Pagar),
              montada a partir dos títulos — sem cadastro manual aqui.
              Para relatórios com KPIs dedicados (ex.: posição CP), use
              <a routerLink="/financial/reports">Relatórios financeiros</a>.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="cashflow-card">
      <div class="cf-mirror-banner">
        <i class="fas fa-arrows-rotate"></i>
        <span>
          Atualizado a partir dos títulos em CR/CP. Ao gerar contrato, receber ou pagar um título, o espelho reflete na próxima consulta.
        </span>
      </div>

      <div class="filters-section">
        <div class="filters-row">
          <div class="filter-group">
            <label class="form-label">Período</label>
            <div class="d-flex gap-2 align-items-center flex-wrap">
              <input type="date" class="form-control" [(ngModel)]="startDate" (change)="onDateRangeChange()" />
              <span class="text-muted">até</span>
              <input type="date" class="form-control" [(ngModel)]="endDate" (change)="onDateRangeChange()" />
            </div>
          </div>

          <div class="filter-group">
            <label class="form-label">Critério de data</label>
            <select class="form-select" [(ngModel)]="dateMode" (ngModelChange)="onDateModeChange()">
              <option value="due">Vencimento</option>
              <option value="settlement">Recebimento / Pagamento</option>
            </select>
          </div>

          <div class="filter-group">
            <label class="form-label">Centro de custo</label>
            <select class="form-select" [(ngModel)]="selectedCostCenterId" (ngModelChange)="onCostCenterFilterChange()">
              <option [ngValue]="null">Todos</option>
              <option *ngFor="let cc of costCenters" [ngValue]="cc.id">{{ cc.name }}</option>
            </select>
          </div>

          <div class="filter-group">
            <label class="form-label">Fluxo</label>
            <select class="form-select" [(ngModel)]="typeFilter" (ngModelChange)="onTypeFilterChange()">
              <option value="all">Entradas e saídas</option>
              <option value="in">Somente entradas</option>
              <option value="out">Somente saídas</option>
            </select>
          </div>

          <div class="filter-actions">
            <button
              type="button"
              class="btn btn-success"
              (click)="exportToExcel()"
              [disabled]="loading || isExporting || entries.length === 0"
              title="Exporta os registros visíveis na tabela (com filtros e busca)">
              <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isExportingExcel" class="fas fa-file-excel me-2"></i>
              {{ isExportingExcel ? 'Exportando...' : 'Exportar Excel' }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="exportToPdf()"
              [disabled]="loading || isExporting || entries.length === 0"
              title="Exporta os registros visíveis em PDF">
              <span *ngIf="isExportingPdf" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isExportingPdf" class="fas fa-file-pdf me-2"></i>
              {{ isExportingPdf ? 'Exportando...' : 'Exportar PDF' }}
            </button>
            <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
              <i class="fas fa-times me-2"></i>
              Limpar
            </button>
          </div>
        </div>
      </div>

      <div class="cf-summary" *ngIf="!loading">
        <div class="cf-summary-card cf-summary-in">
          <span class="cf-summary-label">Entradas ({{ countIn }})</span>
          <span class="cf-summary-value">{{ formatCurrency(totalIn) }}</span>
        </div>
        <div class="cf-summary-card cf-summary-out">
          <span class="cf-summary-label">Saídas ({{ countOut }})</span>
          <span class="cf-summary-value">{{ formatCurrency(totalOut) }}</span>
        </div>
        <div class="cf-summary-card cf-summary-balance" [class.cf-negative]="balance < 0">
          <span class="cf-summary-label">Saldo no período</span>
          <span class="cf-summary-value">{{ formatCurrency(balance) }}</span>
        </div>
        <div class="cf-summary-meta">
          <i class="fas fa-calendar-day me-1"></i>
          Por {{ dateModeLabel }}
        </div>
      </div>

      <div *ngIf="!loading && !error && entries.length > 0" class="table-content">
        <app-table
          [title]="tableTitle"
          [columns]="columns"
          [data]="entries"
          [loading]="loading"
          [showSearch]="showSearch"
          [searchPlaceholder]="searchPlaceholder"
          [clickable]="clickable"
          [actions]="actions"
          [enableSorting]="true"
          [clientSideSort]="true"
          (actionClick)="onActionClick($event)"
          (searchChange)="onSearch($event)"
          (rowClick)="onRowClick($event)">
        </app-table>
      </div>

      <div *ngIf="!loading && !error && entries.length === 0" class="empty-state">
        <i class="fas fa-scale-balanced"></i>
        <h3>Nenhum movimento no período</h3>
        <p>
          Ajuste o período ou o critério de data. Títulos criados ao <strong>gerar contrato</strong> entram em Contas a Receber e aparecem aqui como entrada.
        </p>
      </div>

<div *ngIf="error" class="alert alert-danger mt-3" role="alert">{{ error }}</div>
    </div>
  </div>
</app-side-menu>
